<template>
  <modal :state="state" :index="index" @toggle-modal="emitHideModal" class="xxl">
    <div :slot="ModalStatus.Confirmation">
      <h3 class="modal-title">Configure</h3>

      <div class="row configure-sidebar-section">
        <div class="col-3">
          <scroll-area class="sidebar-edit">
            <draggable v-model="bookmarkMenu.sortedBookmarkFolders" v-bind="VueDraggableDefinition.getOptions()" @change="persistBookmarkFolderMove">
              <div v-for="folder in bookmarkMenu.sortedBookmarkFolders" :key="folder.id" class="align-left">
                <configure-bookmark-folder
                  v-if="!isDashboardFolder(folder)"
                  :folder="folder"
                />
                <hr>
              </div>
            </draggable>
          </scroll-area>

          <button @click="createFolderClicked" class="btn grey-to-blue full-sz">
            Create Menu Folder
          </button>
        </div>

        <div class="col-9" >
          <add-folder
            v-if="interfaceMode === ConfigureSidebarModes.newFolder"
          />
          <edit-folder
            v-if="(interfaceMode === ConfigureSidebarModes.showFolder) || (interfaceMode === ConfigureSidebarModes.editFolder)"
            :folder="selectedFolder"
          />
          <bookmark-link-create-show-edit
            v-if="showBookmarkLinkForm"
            :folder="selectedFolder"
            :existing-link="selectedLink"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
  import Vue from "vue";
  import AddFolder from './add-folder.vue';
  import EditFolder from './edit-folder.vue';
  import BookmarkLinkCreateShowEdit from './bookmark-link-create-show-edit.vue';
  import ConfigureBookmarkFolder from './configure-bookmark-folder.vue';
  import {ConfigureSidebarModes} from "../../enums/configureSidebarModes";
  import BookmarkMenuStoreMixinFactory from '../../mixins/bookmarkMenuStoreMixinFactory';
  import ConfigureSidebarInterfaceStoreMixin from "../../mixins/configureSidebarInterfaceStoreMixin";
  import VueDraggableDefinition from "../../../../common/vue/vueDraggableDefinition";
  import Draggable from 'vuedraggable';
  import {BookmarkFolderType} from "../../enums/bookmarkFolderType";
  const bookmarkMenuStoreMixin = BookmarkMenuStoreMixinFactory({
    state: ['bookmarkMenu'],
    actions: [
      'updateBookmarkFolder',
    ],
  });

  export default Vue.extend({
    mixins: [
      bookmarkMenuStoreMixin,
      ConfigureSidebarInterfaceStoreMixin
    ],
    components: {
      AddFolder,
      EditFolder,
      BookmarkLinkCreateShowEdit,
      ConfigureBookmarkFolder,
      Draggable,
    },
    props: {
      state: Object,
    },
    data: function(): object {
      return {
        ConfigureSidebarModes,
        VueDraggableDefinition
      };
    },
    computed: {
      showBookmarkLinkForm() {
        return (this.interfaceMode === ConfigureSidebarModes.newLink) ||
          (this.interfaceMode === ConfigureSidebarModes.showLink) ||
          (this.interfaceMode === ConfigureSidebarModes.editLink);
      },
    },
    created() {
      this.resetInterface({bookmarkMenu: this.bookmarkMenu});
    },
    methods: {
      createFolderClicked(): void {
        this.setInterfaceMode({mode: ConfigureSidebarModes.newFolder});
      },
      persistBookmarkFolderMove(evt) {
        const bookmarkFolder = evt.moved.element;
        this.updateBookmarkFolder({bookmarkFolder});
      },
      isDashboardFolder(folder) {
        return folder.bookmark_folder_type === BookmarkFolderType.Dashboard
      }
    },
  });
</script>
